import { INPUT_TYPES } from "constants";
import { Row, Col, Form, Collapse, Card, Button, Drawer, Descriptions, message } from 'antd';
import React from 'react';
import cx from "classnames";
import { List, Map, OrderedMap } from "immutable";
import { fieldGenerator, getErrorOnField } from "utilities/form";
import CalculatorDrawer from "./eligibility-calculator/calculator-drawer";
import {
    BANKING_SURROGATE_FORM_FIELDS,
    GST_BASED_FORM_FIELDS,
    FINANCIAL_BASES_FORM_FIELDS,
    WORKING_CAPITAL_GAP_FORM_FIELDS,
    CURRENT_ASSET_METHOD_FORM_FIELDS,
    INDUSTRY_SEGMENT_BASED_FORM_FIELDS
} from "constants/form-fields";
import { CaseService } from "../../services";
import { Table } from "../../components";
import caseService from "../../services/case-service";

var ELIGIBILITY_CALCULATOR_FORM_FIELDS = OrderedMap({
    bankingSurrogate: {
        index: 0,
        label: "Banking Surrogate",
        fields: BANKING_SURROGATE_FORM_FIELDS,
        visible: true
    },
    gstBased: {
        index: 1,
        label: "GST Based",
        fields: GST_BASED_FORM_FIELDS,
        visible: true
    },
    financialsBased: {
        index: 2,
        label: "Financials Based",
        fields: FINANCIAL_BASES_FORM_FIELDS,
        visible: true
    },
    workingCapialGapMethod : {
        index : 3,
        label : "Working Capital Gap Method",
        fields : WORKING_CAPITAL_GAP_FORM_FIELDS,
        visible: true
    },
    currentAssetMethod : {
        index : 4,
        label : "Current Asset Method",
        fields : CURRENT_ASSET_METHOD_FORM_FIELDS,
        visible: true
    },
    industrySegmentBased : {
        index : 5,
        label : "Industry segment based",
        fields : INDUSTRY_SEGMENT_BASED_FORM_FIELDS,
        visible: true
    }
});

class EligibilityCalculator extends React.Component {
    state = {
        visible: false,
        currentActiveFormKey: ELIGIBILITY_CALCULATOR_FORM_FIELDS.toList().first().key,
        calculatorData: Map(),
        usedJob : {},
    }
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);


    componentDidMount() {
        this.fetchEligibilityCalculatorDetails();
        const {bankStatementAnalyser} = this.props;
        const jobListStatus = bankStatementAnalyser && bankStatementAnalyser.getIn(["jobList", "status"]);
        const jobList = bankStatementAnalyser && bankStatementAnalyser.getIn(["jobList", "data"]);
        if(jobListStatus === "FETCHED" && (jobList.size || jobList.length) && !this.state.selectedJob) {
            let usedJob = jobList.find(_ => _.using);
            this.setState({
                usedJob
            })
        }
    }

    fetchEligibilityCalculatorDetails = () => {
        CaseService.getEligibilityCalculatorDetails(this.props.caseId)
            .then(({ data }) => {
                this.setState({
                    calculatorData: Map(data['json_data'])
                })
            })
            .catch((err) => {
                message.error("Something Went Wrong");
            })
    }

    handlePopUp = () => {
        this.setState({
            visible: !this.state.visible
        })
    }

    renderBankingSurrogate = () => {
        return (
            BANKING_SURROGATE_FORM_FIELDS
                .map((field, fieldName) => {
                    return this.fieldGenerator(fieldName, field, this.getErrorOnField(fieldName))();
                })
                .toList()
                .toArray()
        )
    }

    renderGstBased = () => {
        return (
            GST_BASED_FORM_FIELDS
                .map((field, fieldName) => {
                    return this.fieldGenerator(fieldName, field, this.getErrorOnField(fieldName))();
                })
                .toList()
                .toArray()
        )
    }

    renderFinancialsBased = () => {
        return (
            FINANCIAL_BASES_FORM_FIELDS
                .map((field, fieldName) => {
                    return this.fieldGenerator(fieldName, field, this.getErrorOnField(fieldName))();
                })
                .toList()
                .toArray()
        )
    }



    handleEditForm = (formKey) => {
        this.setState({
            visible: true,
            currentActiveFormKey: formKey

        })
    }

    bankingSurrogateData = () => {
        const {caseDetail, bankStatementAnalyser}= this.props;
        const {usedJob} = this.state;
        const stats = bankStatementAnalyser && usedJob  ? bankStatementAnalyser.getIn(["statementAnalysis", usedJob.id, "data"]) : {};
        let data = {
            abb_last_six_months : stats && stats.monthlyAvgBalance > 0 ? stats.monthlyAvgBalance : '',
            average_utilized_limit : stats && stats.monthlyAvgBalance  < 0 ? stats.monthlyAvgBalance : '',
            margin_b:caseDetail.bank == "HHPL" ? 50 : 40,
            tenor_c: parseInt(caseDetail.tenure) || null,
            od_limit: 0
        }
        return data
    }
    gstBasedData = () => {
         const {caseDetail}= this.props;
        let data = {

            margin_b_gst: caseDetail.bank.code == "HHPL" ?  30 : caseDetail.bank.code == "KSF"  ? 8 : "",
            foir_c : caseDetail.bank.code == "HHPL" ?  100 : caseDetail.bank.code == "KSF"  ? 75 : "",
            gst_topline_last_twelve_months_a:  Number(this.last_twelve_months_sale().toFixed(2)) || 0,
            current_obligation_running_emi_for_twelve_months_e: 0,
        }
        return data
    }
    financialsBasedData = () => {
        let data = {
            pat_a: this.props.calculatorData.pnl_pat || 0,
            interest_b_financial: this.props.calculatorData.pnl_finance_cost_interest_paid || 0,
            depriciation_c: this.props.calculatorData.pnl_expense_depreciation || 0,
            partner_remuneration_int_on_capital: 0,
            twelve_month_existing_emi: 0,
            twelve_month_new_emi: 0,
        }
        return data
    }
    workingCapialGapMethodData = () => {
        let data = {
            creditor_in_days : Math.round(this.props.calculatorData.ratio_creditor_turnover_days) || 0,
            stock_in_days:   Math.round(this.props.calculatorData.stock_in_days) || 0,
            debtors_in_days : Math.round(this.props.calculatorData.ratio_debtor_turnover_days) || 0,
            working_capital_cycle : this.props.calculatorData.ratio_net_working_capital || 0,
            last_twelve_months_sales: Number(this.last_twelve_months_sale().toFixed(2)) || 0,
            existing_working_capital_limits: 0
        } 
        return data
    }
    currentAssetMethodData = () => {
        let data = {
            current_asset_debtors : this.props.calculatorData.debtors || 0,
            stoct_current_asset : this.props.calculatorData.closing_stock || 0,
            stock_wip: 0,
            existing_loans: 0
        }
        return data 
    }
    industrySegmentBasedData = () => {
        let data = {
            industry_segment_gst_topline_last_twelve_month: Number(this.last_twelve_months_sale().toFixed(2)) || 0
        }
        return data 
    }
          


    last_twelve_months_sale = () => {
        // const inputDate = new Date();
        // const months = [];
        // for (let i = 0; i < 12; i++) {
        //     const date = new Date(inputDate.getFullYear() - 1, inputDate.getMonth() - i, 1);
        //     const month = String(date.getMonth()).padStart(2, '0'); // 01 to 12
        //     const year = date.getFullYear();
        //     months.push(`${year}-${month}-01`);
        // }
        // console.log("this.props.financialsData ", this.props.financialsData)
        if (this.props.financialsData && this.props.financialsData.size) {
            // let obj = {}
            // this.props.financialsData.map((_) => {
            //     obj[Object.keys(_)] = Object.values(_)[0]
            // })
            // let sales = 0;
            // months.map((_) => {
            //     sales += (obj[_] || 0)
            // })
            // return sales
            let arr = this.props.financialsData.toJS();
            const lastNonZeroIndex = arr.length - 1 - arr.slice().reverse().findIndex(v => v !== 0);

            const result = arr.slice(Math.max(0, lastNonZeroIndex - 11), lastNonZeroIndex + 1);
            console.log('result', result);
            return result.reduce((sum, item) => sum + Object.values(item)[0], 0) / 100000;

        }
        return 0
    }

    render() {
        const { usedJob } = this.state;
        const { bankStatementAnalyser } = this.props;
        const calculatorData = this.state.calculatorData
            .setIn(
                ['bankingSurrogate'],
                this.state.calculatorData.get('bankingSurrogate') || this.bankingSurrogateData()
            )
            .setIn(
                ['gstBased'],
                this.state.calculatorData.get('gstBased') || this.gstBasedData()
            )
            .setIn(
                ['financialsBased'],
                this.state.calculatorData.get('financialsBased') || this.financialsBasedData()
            )
            .setIn(
                ['workingCapialGapMethod'],
                this.state.calculatorData.get('workingCapialGapMethod') || this.workingCapialGapMethodData()
            )
            .setIn(
                ['currentAssetMethod'],
                this.state.calculatorData.get('currentAssetMethod') || this.currentAssetMethodData()
            ).setIn(
                ['industrySegmentBased'],
                this.state.calculatorData.get('industrySegmentBased') || this.industrySegmentBasedData()
            );


        const maxExposure = {
            bankingSurrogate: this.props.isKSFTl ?  43 : 500,
            gstBased: this.props.isKSFTl ?  43 : 500,
            financialsBased: this.props.isKSFTl ? 60 : 500
        }
        if(!this.props.isKSFTl){
            ELIGIBILITY_CALCULATOR_FORM_FIELDS = ELIGIBILITY_CALCULATOR_FORM_FIELDS
            .setIn(['workingCapialGapMethod' , 'visible'] , true)
            .setIn(['currentAssetMethod' , 'visible'] , true)
            .setIn(['industrySegmentBased' , 'visible'] , true)

        }else{
            ELIGIBILITY_CALCULATOR_FORM_FIELDS = ELIGIBILITY_CALCULATOR_FORM_FIELDS
            .setIn(['workingCapialGapMethod' , 'visible'] , false)
            .setIn(['currentAssetMethod' , 'visible'] , false)
            .setIn(['industrySegmentBased' , 'visible'] , false)

        }
        return (
            <Col span={24} className={"p-10"}>
                <Card title="Eligibility Calculator" className={"padless-card"}>
                    {this.state.visible && <CalculatorDrawer
                        formFields={ELIGIBILITY_CALCULATOR_FORM_FIELDS.getIn([this.state.currentActiveFormKey, 'fields'])}
                        visible={this.state.visible}
                        onClose={this.handlePopUp}
                        currentActiveFormKey={this.state.currentActiveFormKey}
                        caseId={this.props.caseId}
                        values={calculatorData.size && this.state.currentActiveFormKey && Map(calculatorData.get(this.state.currentActiveFormKey))}
                        fetchEligibilityCalculatorDetails={this.fetchEligibilityCalculatorDetails}
                        bankStatementAnalyser={this.props.bankStatementAnalyser}
                        usedJob={usedJob}
                    />}
                    <Row>
                        <Form className={cx("form", "p-10", "br-3")}>
                            {ELIGIBILITY_CALCULATOR_FORM_FIELDS.map((_, key) => {
                                if(!_.visible){
                                    return <></>
                                }
                                return <Col span={7} offset={![0, 3].includes(_.index) ? 1 : 1} key={key}>
                                    <Descriptions bordered span={1} size="small" column={2} title={<>{_.label} <Button type="link" onClick={() => this.handleEditForm(key)}>Edit</Button></>} layout={"vertical"}>
                                        {_.fields.map((__, key2) => {
                                            return <Descriptions.Item className={__.showInputBgColor ? "input-bg-color" : ""} label={__.label}>{calculatorData.size && calculatorData.getIn([key, key2]) || '-'}</Descriptions.Item>
                                        }).toList()
                                            .toArray()}
                                    </Descriptions>
                                </Col>
                            }).toList()}
                        </Form>
                    </Row>

                    {this.state.calculatorData.size && <Row className="mt-10">
                        <Table
                            showFilters={false}
                            showColumnSelector={false}
                            noRowSelection={true}
                            data={List([{
                                "surrogate": "Banking surrogate",
                                "max_exposure": maxExposure['bankingSurrogate'],
                                "calculated_eligibility": this.state.calculatorData.getIn(["bankingSurrogate", "max_loan_eligibility_abc"]),
                                "final_eligibility": this.state.calculatorData.getIn(['bankingSurrogate', 'max_loan_eligibility_abc']) > maxExposure['bankingSurrogate'] ? maxExposure['bankingSurrogate'] : this.state.calculatorData.getIn(['bankingSurrogate', 'max_loan_eligibility_abc'])
                            }, {
                                "surrogate": "GST based",
                                "max_exposure": maxExposure['gstBased'],
                                "calculated_eligibility": this.state.calculatorData.getIn(['gstBased', 'max_loan_eligibility_d_e']),
                                "final_eligibility": this.state.calculatorData.getIn(['gstBased', 'max_loan_eligibility_d_e']) > maxExposure['gstBased'] ? maxExposure['gstBased'] : this.state.calculatorData.getIn(['gstBased', 'max_loan_eligibility_d_e'])

                            }, {
                                "surrogate": "Financials based",
                                "max_exposure": maxExposure['financialsBased'],
                                "calculated_eligibility": this.state.calculatorData.getIn(['financialsBased', 'twelve_month_new_emi']),
                                "final_eligibility": this.state.calculatorData.getIn(['financialsBased', 'twelve_month_new_emi']) > maxExposure['financialsBased'] ? maxExposure['financialsBased'] : this.state.calculatorData.getIn(['financialsBased', 'twelve_month_new_emi'])
                            }])}
                            columns={OrderedMap({
                                surrogate: {
                                    title: "Surrogate",
                                    dataIndex: "surrogate",
                                    key: "surrogate",
                                    width: 250,
                                    align: "center"
                                },
                                calculated_eligibility: {
                                    title: "Calculated Eligibility (values in lakhs)",
                                    dataIndex: "calculated_eligibility",
                                    key: "calculated_eligibility",
                                    width: 300,
                                    align: "center",
                                },
                                max_exposure: {
                                    title: "Max exposure (values in lakhs)",
                                    dataIndex: "max_exposure",
                                    key: "max_exposure",
                                    width: 300,
                                    align: "center",
                                },
                                final_eligibility: {
                                    title: "Final Eligibility (values in lakhs)",
                                    dataIndex: "final_eligibility",
                                    key: "final_eligibility",
                                    width: 300,
                                    align: "center",
                                },
                            })}
                        />
                    </Row>}


                </Card>




            </Col>

        )
    }
}

export default Form.create({
    mapPropsToFields: ({ values }) => {
        return (
            values &&
            values
                .toSeq()
                .toMap()
                .map((value, key) => {
                    if (key === "sanction_date" || key === "agreement_end_date") {
                        return Form.createFormField({
                            value: value && moment(value)
                        });
                    }
                    return Form.createFormField({
                        value
                    });
                })
                .toJS()
        );
    }
})(EligibilityCalculator);